import { useLocation } from '@reach/router';
import Link from 'gatsby-plugin-transition-link';
import gsap from 'gsap';
import React, { FunctionComponent } from 'react';

interface TransitionLinkProps {
  activeClassName?: string;
  className?: string;
  ref?: any;
  state?: any;
  to: string;
}

const ANIMATION_LENGTH = 0.8;

const TransitionLink: FunctionComponent<TransitionLinkProps> = React.forwardRef(
  ({ activeClassName, children, className, to, ...props }, ref) => {
    const location = useLocation();

    return (
      <Link
        activeClassName={activeClassName}
        className={className}
        to={to}
        ref={ref}
        exit={{
          length: ANIMATION_LENGTH,
          trigger: ({ node }) => {
            gsap.to(node, {
              duration: ANIMATION_LENGTH,
              ease: 'expo.inOut',
              y: -window.innerHeight,
            });
          },
        }}
        entry={{
          delay: 0,
          length: ANIMATION_LENGTH,
          trigger: ({ node }) => {
            gsap.set(node, {
              y: window.innerHeight,
            });

            gsap.to(node, {
              duration: ANIMATION_LENGTH,
              ease: 'expo.inOut',
              y: 0,
            });

            // We're going to the index page
            if (to === '/') {
              gsap.set('.header', {
                color: 'black',
              });

              gsap.to('.header', {
                color: 'white',
                delay: 0.65 * ANIMATION_LENGTH,
                duration: 0.35 * ANIMATION_LENGTH,
              });
            }

            // We're leaving the index page
            if (location.pathname === '/') {
              gsap.set('.header', {
                color: 'white',
              });

              gsap.to('.header', {
                color: 'black',
                delay: 0.65 * ANIMATION_LENGTH,
                duration: 0.35 * ANIMATION_LENGTH,
              });
            }

            // We're leaving a page with header and we're going to a page w/o header
            if (
              !location.pathname.match(/\/artists\/.+/) &&
              !location.pathname.match(/\/projects\/.+/) &&
              (to.match(/\/artists\/.+/) || to.match(/\/projects\/.+/))
            ) {
              gsap.to('.header', {
                duration: ANIMATION_LENGTH,
                ease: 'expo.inOut',
                y: -window.innerHeight,
              });
            }

            // We're leaving a page w/o header and we're going to a page with header
            if (
              (location.pathname.match(/\/artists\/.+/) ||
                location.pathname.match(/\/projects\/.+/)) &&
              !to.match(/\/artists\/.+/) &&
              !to.match(/\/projects\/.+/)
            ) {
              gsap.set('.header', {
                display: 'flex',
                y: window.innerHeight,
              });

              gsap.to('.header', {
                duration: ANIMATION_LENGTH,
                ease: 'expo.inOut',
                y: 0,
              });
            }
          },
        }}
        {...props}
      >
        {children}
      </Link>
    );
  },
);

export default TransitionLink;
